import { Autocomplete, Box, Button, Dialog, Grid, IconButton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { COMMON_STYLE, CurrencySymbol, NEW_DOC_EYE_TYPE } from '../../../Utility/Constants';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { getClinicIdWithContext } from '../../../Utility/Services/CacheProviderService';

const STYLE = {
    WIDTH: '18dvw'
}

const UmaCounsellor = (props) => {
    const [counsellor, setCounsellor] = useState({
    selectedSurgeryName: '',
    selectedPackageName: '',
    selectedSurgeonName: '',
    selectedEyeType: '',
    selectedAnaesthetist: '',
    selectedCounsellor: '',
    iolPower: '',
    selectedIOLSymbol: true,
    doctorComments: '',
    counsellorComments: '',
    surgerySugg: [],
    packageSugg: [],
    surgeonSugg: [],
    eyeSugg: NEW_DOC_EYE_TYPE,
    anaesthetistSugg: [],
    counsellorSugg: [],
    counsellorSurgeryData: [],
    counsellorData: [],
    transmit: false,
    saveLoad: false,
    disableTransmit: false,
    transmitId: false,
    counsellorSts: ''
})
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    useEffect(async () => {
        if (props.props.clinic_id && props.props.appointment_id && props.props.patient_id) {
            await getSurgeryList()
            await getDoctorList()
            await getCounsellorList()
            // await getCounsellorSurgeryData()
        }
    }, [props.props.clinic_id, props.props.appointment_id, props.props.patient_id])

    useEffect(async () => {
        if (counsellor.transmit) {
            await postCounsellorData()
        }
        if (counsellor.saveLoad) {
            postCounsellorData()
        }
    }, [counsellor.transmit, counsellor.saveLoad])

    const getSurgeryList = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_COUNSELLING_SURGERY_SEARCH + '?clinic_id=' + (props?.props?.clinic_id ?? getClinicIdWithContext()))
            if (response?.data?.status === 'success') {
                setCounsellor((prev) => ({
                    ...prev,
                    surgerySugg: response?.data?.data || []
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getPackageList = async (search) => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_COUNSELLING_SURGERY_SEARCH +
                '?surgery_key=' + search + '&clinic_id=' + (props?.props?.clinic_id ?? getClinicIdWithContext())
            )
            if (response?.data?.status === 'success') {
                setCounsellor((prev) => ({
                    ...prev,
                    packageSugg: response?.data?.data || []
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getDoctorList = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.HOME_GET_CLINIC_DOCTORS + '?clinic_id=' + props?.props?.clinic_id)
            if (response?.data?.status === 'success') {
                setCounsellor((prev) => ({
                    ...prev,
                    surgeonSugg: response?.data?.data || [],
                    anaesthetistSugg: response?.data?.data || []
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getCounsellorList = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_SURGERY_DETAILS +
                '?patient_id=' + props?.props?.patient_id + '&appointment_id=' + props?.props?.appointment_id + '&clinic_id=' + (props?.props?.clinic_id ?? getClinicIdWithContext())
            )
            if (response?.data?.status === 'success') {
                setCounsellor((prev) => ({
                    ...prev,
                    counsellorSugg: response?.data?.data?.counsellor_details?.length > 0 ? response?.data?.data?.counsellor_details : [],

                    counsellorSurgeryData: Object.keys(response?.data?.data?.surgery_details)?.length > 0 ? [response?.data?.data?.surgery_details] : [],
                    selectedSurgeryName: response?.data?.data?.surgery_details?.surgery_name || '',
                    selectedPackageName: response?.data?.data?.surgery_details?.package_name || '',
                    selectedSurgeonName: response?.data?.data?.surgery_details?.surgeon_name || '',
                    selectedEyeType: response?.data?.data?.surgery_details?.eye_type || '',
                    selectedAnaesthetist: response?.data?.data?.surgery_details?.anaesthetist || '',
                    selectedCounsellor: response?.data?.data?.surgery_details?.counsellor_name || '',
                    iolPower: response?.data?.data?.surgery_details?.iol_power ? String(response?.data?.data?.surgery_details?.iol_power)?.substring(1) : '',
                    selectedIOLSymbol: +response?.data?.data?.surgery_details?.iol_power < 0 ? false : true,
                    doctorComments: response?.data?.data?.surgery_details?.doctor_notes || '',
                    counsellorComments: response?.data?.data?.surgery_details?.counsellor_notes || '',

                    counsellorSts: response?.data?.data?.surgery_details?.status || '',
                    transmitId: response?.data?.data?.surgery_details?.id ? true : false,
                    disableTransmit: (response?.data?.data?.surgery_details?.status === 'Transmitted' || response?.data?.data?.surgery_details?.status === "Approved") ? true : false,
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getCounsellorSurgeryData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_COUNSELLOR + '?appointment_id=' + props?.props?.appointment_id)
            if (response?.data?.status === 'success') {
                setCounsellor((prev) => ({
                    ...prev,
                    counsellorSurgeryData: Object.keys(response?.data?.data)?.length > 0 ? [response?.data?.data] : [],
                    selectedSurgeryName: response?.data?.data?.surgery_name || '',
                    selectedPackageName: response?.data?.data?.package_name || '',
                    selectedSurgeonName: response?.data?.data?.surgeon_name || '',
                    selectedEyeType: response?.data?.data?.eye_type || '',
                    selectedAnaesthetist: response?.data?.data?.anaesthetist || '',
                    selectedCounsellor: response?.data?.data?.counsellor_name || '',
                    iolPower: response?.data?.data?.iol_power ? String(response?.data?.data?.iol_power)?.substring(1) : '',
                    selectedIOLSymbol: +response?.data?.data?.iol_power < 0 ? false : true,
                    doctorComments: response?.data?.data?.notes || '',
                    counsellorComments: response?.data?.data?.counsellor_notes || '',

                    counsellorSts: response?.data?.data?.status || '',
                    transmitId: response?.data?.data?.id ? true : false,
                    disableTransmit: (response?.data?.data?.status === 'Transmitted' || response?.data?.data?.status === "Approved") ? true : false,
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const checkValidation = () => {
        try {
            let message = null;
            if (counsellor.selectedEyeType === '') {
                message = 'Select Eye Type'
            } else if (counsellor.selectedCounsellor === '') {
                message = 'Select Counsellor'
            } else if (counsellor.selectedSurgeonName === '') {
                message = 'Select Surgeon Name'
            }
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postCounsellorData = async () => {
        try {
            let date = new Date()
            let transDate = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd HH:mm:ss')
            // let data = {
            //     appointment_id: props?.props.appointment_id,
            //     eye_type: counsellor.selectedEyeType?.label || counsellor.selectedEyeType || counsellor.counsellorSurgeryData[0]?.eye_type,
            //     package_id: counsellor.selectedPackageName?.package_id || counsellor.counsellorSurgeryData[0]?.package_id,
            //     surgery_id: counsellor.selectedSurgeryName?.surgery_id || counsellor.counsellorSurgeryData[0]?.surgery_id,
            //     counsellor_id: counsellor.selectedCounsellor?.counsellor_id || counsellor.counsellorSurgeryData[0]?.counsellor_id,
            //     surgeon_name: counsellor.selectedSurgeonName?.first_name || counsellor.counsellorSurgeryData[0]?.surgery_name,
            //     anaesthetist: counsellor.selectedAnaesthetist?.first_name || counsellor.counsellorSurgeryData[0]?.anaesthetist,
            //     counsellor_name: counsellor.selectedCounsellor?.counsellor_name || counsellor.counsellorSurgeryData[0]?.counsellor_name,
            //     iol_power: (counsellor.selectedIOLSymbol ? `+${counsellor.iolPower}` : `-${counsellor.iolPower}`),
            //     notes: counsellor.doctorComments || counsellor.counsellorSurgeryData[0]?.notes,
            //     status: counsellor.transmit ? 'Transmitted' : '',
            //     transmitted_date: counsellor.transmit ? transDate : null,
            // }
            let data = {}
            if (counsellor.transmit) {
                data = {
                    appointment_id: props?.props.appointment_id,
                    clinic_id: +props?.props.clinic_id,
                    patient_id: props?.props.patient_id,
                    id: counsellor.counsellorSurgeryData[0]?.id || null,
                    surgery_id: counsellor.selectedSurgeryName?.surgery_id || counsellor.counsellorSurgeryData[0]?.surgery_id,
                    counsellor_id: counsellor.selectedCounsellor?.counsellor_id || counsellor.counsellorSurgeryData[0]?.counsellor_id,
                    status: 'Transmitted'
                }
            } else {
                data = {
                    anaesthetist: counsellor.selectedAnaesthetist?.first_name || counsellor.counsellorSurgeryData[0]?.anaesthetist,
                    appointment_id: props?.props.appointment_id,
                    clinic_id: +props?.props.clinic_id,
                    counsellor_name: counsellor.selectedCounsellor?.counsellor_name || counsellor.counsellorSurgeryData[0]?.counsellor_name,
                    counsellor_id: counsellor.selectedCounsellor?.counsellor_id || counsellor.counsellorSurgeryData[0]?.counsellor_id,
                    notes: counsellor.doctorComments || counsellor.counsellorSurgeryData[0]?.notes,
                    // package_id: this.state.package == "" ? null : this.state.surgery?.id ? this.state.surgery?.id : this.state.counsellorData?.surgery_details?.package_id ? this.state.counsellorData?.surgery_details?.package_id : null,
                    package_id: counsellor.selectedPackageName?.package_id || counsellor.counsellorSurgeryData[0]?.package_id,
                    patient_id: props?.props.patient_id,
                    surgeon_name: counsellor.selectedSurgeonName?.first_name || counsellor.counsellorSurgeryData[0]?.surgery_name,
                    surgery_id: counsellor.selectedSurgeryName?.surgery_id || counsellor.counsellorSurgeryData[0]?.surgery_id,
                    status: null,
                    id: counsellor.counsellorSurgeryData[0]?.id || null,
                    eye_type: counsellor.selectedEyeType?.label || counsellor.selectedEyeType || counsellor.counsellorSurgeryData[0]?.eye_type,
                    iol_power: counsellor.iolPower ? (counsellor.selectedIOLSymbol ? `+${counsellor.iolPower}` : `-${counsellor.iolPower}`) : null
                }
            }

            let check = checkValidation()
            if (check === null) {
                const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_COUNSELLOR)
                if (response?.data?.status === 'success') {
                    successMessage(response?.data?.message)
                    // await getCounsellorSurgeryData()
                    await getCounsellorList()
                    setCounsellor((prev) => ({
                        ...prev,
                        selectedIOLSymbol: true,
                        transmit: false,
                        saveLoad: false
                    }))
                }
            } else {
                setCounsellor((prev) => ({ ...prev, saveLoad: false }))
                errorMessage(check)
            }
        } catch (error) {
            setCounsellor((prev) => ({ ...prev, saveLoad: false }))
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const onClearHandler = () => {
        try {
            setCounsellor((prev) => ({
                ...prev,
                selectedSurgeryName: '',
                selectedPackageName: '',
                selectedSurgeonName: '',
                selectedEyeType: '',
                selectedAnaesthetist: '',
                selectedCounsellor: '',
                iolPower: '',
                selectedIOLSymbol: true,
                doctorComments: '',
                counsellorComments: '',
                packageSugg: [],
                transmit: false,
                saveLoad: false
            }))
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderCounsellorSurgeryTbl = () => {
        try {
            return (
                <Box component={'div'} sx={{ mt: '1rem' }} border={'1px solid lightgray'}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell className='doc_notes_tbl_header'>Surgery</TableCell>
                                <TableCell className='doc_notes_tbl_header'>Package Name</TableCell>
                                <TableCell className='doc_notes_tbl_header'>Surgery Date</TableCell>
                                <TableCell className='doc_notes_tbl_header'>Surgery Time</TableCell>
                                <TableCell className='doc_notes_tbl_header'>Surgeon Name</TableCell>
                                <TableCell className='doc_notes_tbl_header'>Anaesthetist</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {counsellor.counsellorSurgeryData?.length > 0 ? counsellor.counsellorSurgeryData?.map((item, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell className='doc_notes_tbl_body_cell'>{item?.surgery_name || '-'}</TableCell>
                                        <TableCell className='doc_notes_tbl_body_cell'>{item?.package_name || '-'}</TableCell>
                                        <TableCell className='doc_notes_tbl_body_cell'>{item?.surgery_date || '-'}</TableCell>
                                        <TableCell className='doc_notes_tbl_body_cell'>{item?.surgery_time || '-'}</TableCell>
                                        <TableCell className='doc_notes_tbl_body_cell'>{item?.surgeon_name || '-'}</TableCell>
                                        <TableCell className='doc_notes_tbl_body_cell'>{item?.anaesthetist || '-'}</TableCell>
                                    </TableRow>
                                )
                            }) : <TableRow><TableCell align='center' colSpan={6}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderCounsellorTbl = () => {
        try {
            return (
                <Box component={'div'}>
                    <Box component={'div'} sx={{ mt: '1rem' }} border={'1px solid lightgray'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_header'>Package Name</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>{`Amount (${CurrencySymbol})`}</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>{`Discount (${CurrencySymbol})`}</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>{`Discount (%)`}</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>{`Bill Amount (${CurrencySymbol})`}</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {counsellor.counsellorSurgeryData?.length > 0 ? counsellor.counsellorSurgeryData?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell'>{item?.package_name || '-'}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>{item?.amount || '0'}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>{item?.discount_amount || '0'}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>{item?.discount_percentage || '0'}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>{item?.net_amount || '0'}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>{item?.status || '-'}</TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={6}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                    <Box component={'div'} mt={'0.5rem'}>
                        <Typography className='doc_notes_header_card_font'>Counseller Comments</Typography>
                        <Box component={'div'} mt={'0.5rem'}>
                            <TextField
                                size='small'
                                multiline
                                rows={4}
                                maxRows={4}
                                disabled
                                fullWidth
                                value={counsellor.counsellorComments}
                                onChange={(e) => {
                                    if (e.target.value?.length <= 1000) {
                                        setCounsellor((prev) => ({ ...prev, counsellorComments: e.target.value }))
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <Dialog open={true} maxWidth="lg" fullWidth>
            <Box className='doc_addendum_popup'>
                <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                    <Typography className='doc_notes_header_card_font'>Move To Counsellor</Typography>
                    <IconButton
                        onClick={() => { props.onClosePopup(false) }}
                    ><CloseIcon /></IconButton>
                </Box>
                <Box component={'div'} p={'0.5rem'} maxHeight={'70dvh'} overflow={'auto'}>
                    <Grid container>
                        <Grid xs={3}>
                            <Typography className='doc_notes_header_card_font'>Select Or Search Surgery</Typography>
                            <Box component={'div'} mt={'0.5rem'}>
                                <Autocomplete
                                    disabled={props?.props?.patient_transfered}
                                    clearIcon
                                    size='small'
                                    sx={{ width: STYLE.WIDTH }}
                                    options={counsellor.surgerySugg || []}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.surgery_key}
                                    value={counsellor.selectedSurgeryName}
                                    onChange={(e, newValue) => {
                                        setCounsellor((prev) => ({ ...prev, selectedSurgeryName: newValue, selectedPackageName: null }))
                                        if (newValue) {
                                            getPackageList(newValue?.surgery_key)
                                        }
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        placeholder='Select or Search Surgery'
                                    />}
                                />
                            </Box>
                        </Grid>
                        <Grid xs={3}>
                            <Typography className='doc_notes_header_card_font'>Select Package</Typography>
                            <Box component={'div'} mt={'0.5rem'}>
                                <Autocomplete
                                    disabled={props?.props?.patient_transfered}
                                    clearIcon
                                    size='small'
                                    sx={{ width: STYLE.WIDTH }}
                                    options={counsellor.packageSugg || []}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.package_name}
                                    value={counsellor.selectedPackageName}
                                    onChange={(e, newValue) => {
                                        setCounsellor((prev) => ({ ...prev, selectedPackageName: newValue }))
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        placeholder='Select Package'
                                    />}
                                />
                            </Box>
                        </Grid>
                        <Grid xs={3}>
                            <Typography className='doc_notes_header_card_font'>Surgeon Name *</Typography>
                            <Box component={'div'} mt={'0.5rem'}>
                                <Autocomplete
                                    disabled={props?.props?.patient_transfered}
                                    clearIcon
                                    size='small'
                                    sx={{ width: STYLE.WIDTH }}
                                    options={counsellor.surgeonSugg || []}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.first_name}
                                    value={counsellor.selectedSurgeonName}
                                    onChange={(e, newValue) => {
                                        setCounsellor((prev) => ({ ...prev, selectedSurgeonName: newValue }))
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        placeholder='Select Surgeon'
                                    />}
                                />
                            </Box>
                        </Grid>
                        <Grid xs={3}>
                            <Typography className='doc_notes_header_card_font'>Select Eye Type *</Typography>
                            <Box component={'div'} mt={'0.5rem'}>
                                <Autocomplete
                                    disabled={props?.props?.patient_transfered}
                                    clearIcon
                                    size='small'
                                    sx={{ width: STYLE.WIDTH }}
                                    options={counsellor.eyeSugg || []}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                                    value={counsellor.selectedEyeType}
                                    onChange={(e, newValue) => {
                                        setCounsellor((prev) => ({ ...prev, selectedEyeType: newValue }))
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        placeholder='Select Eye Type'
                                    />}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ mt: '1rem' }}>
                        <Grid xs={3}>
                            <Typography className='doc_notes_header_card_font'>Select Anaesthetist</Typography>
                            <Box component={'div'} mt={'0.5rem'}>
                                <Autocomplete
                                    disabled={props?.props?.patient_transfered}
                                    clearIcon
                                    size='small'
                                    sx={{ width: STYLE.WIDTH }}
                                    options={counsellor.anaesthetistSugg || []}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.first_name}
                                    value={counsellor.selectedAnaesthetist}
                                    onChange={(e, newValue) => {
                                        setCounsellor((prev) => ({ ...prev, selectedAnaesthetist: newValue }))
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        placeholder='Select Anaesthetist'
                                    />}
                                />
                            </Box>
                        </Grid>
                        <Grid xs={3}>
                            <Typography className='doc_notes_header_card_font'>Select Counsellor *</Typography>
                            <Box component={'div'} mt={'0.5rem'}>
                                <Autocomplete
                                    disabled={props?.props?.patient_transfered}
                                    clearIcon
                                    size='small'
                                    sx={{ width: STYLE.WIDTH }}
                                    options={counsellor.counsellorSugg || []}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.counsellor_name}
                                    value={counsellor.selectedCounsellor}
                                    onChange={(e, newValue) => {
                                        setCounsellor((prev) => ({ ...prev, selectedCounsellor: newValue }))
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        placeholder='Select Counsellor'
                                    />}
                                />
                            </Box>
                        </Grid>
                        <Grid xs={3}>
                            <Typography className='doc_notes_header_card_font'>IOL Power</Typography>
                            <Box component={'div'} mt={'0.5rem'}>
                                <TextField
                                    disabled={props?.props?.patient_transfered}
                                    size='small'
                                    sx={{ width: STYLE.WIDTH }}
                                    value={counsellor.iolPower}
                                    onChange={(e) => { setCounsellor((prev) => ({ ...prev, iolPower: e.target.value })) }}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => setCounsellor((prev) => ({ ...prev, selectedIOLSymbol: !counsellor.selectedIOLSymbol }))}
                                            >{counsellor.selectedIOLSymbol ? <AddIcon color='primary' /> : <RemoveIcon color='primary' />}</IconButton>
                                        )
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    <Box component={'div'} sx={{ mt: '1rem' }}>
                        <Typography className='doc_notes_header_card_font'>Doctor Notes</Typography>
                        <Box component={'div'} mt={'1rem'}>
                            <TextField
                                disabled={props?.props?.patient_transfered}
                                size='small'
                                multiline
                                rows={4}
                                maxRows={4}
                                fullWidth
                                value={counsellor.doctorComments}
                                onChange={(e) => {
                                    if (+e.target.value?.length <= 1000) {
                                        setCounsellor((prev) => ({ ...prev, doctorComments: e.target.value }))
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                    <Box component={'div'}>{renderCounsellorSurgeryTbl()}</Box>
                    <Box component={'div'} mt={'0.5rem'}>
                        <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <Typography className='doc_notes_header_card_font'>Counseller Details</Typography>
                        </Box>
                        <Typography className='doc_notes_header_card_font'>Package Details</Typography>
                        {renderCounsellorTbl()}
                    </Box>
                </Box>
                <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} mb={'1rem'}>
                    <Button sx={{ textTransform: 'capitalize', mr: '0.5rem', height: '4.5dvh' }} variant='outlined'
                        disabled={props?.props?.patient_transfered}
                        onClick={() => onClearHandler()}
                    >Clear</Button>
                    <Button sx={{ textTransform: 'capitalize', mr: '0.5rem', height: '4.5dvh' }} variant='contained'
                        disabled={props?.props?.patient_transfered || counsellor.saveLoad || counsellor.counsellorSts === "Transmitted" || counsellor.counsellorSts === "Draft" || counsellor.counsellorSts === "Completed" || counsellor.counsellorSts === "Approved"}
                        onClick={() => setCounsellor((prev) => ({ ...prev, saveLoad: true }))}
                    >Save</Button>
                    <Button sx={{ textTransform: 'capitalize', mr: '0.5rem', height: '4.5dvh' }} variant='contained'
                        disabled={props?.props?.patient_transfered || counsellor.transmit || !counsellor.transmitId || counsellor.counsellorSts === "Transmitted" || counsellor.counsellorSts === "Draft" || counsellor.counsellorSts === "Completed" || counsellor.counsellorSts === "Approved"}
                        onClick={() => setCounsellor((prev) => ({ ...prev, transmit: true }))}
                    >Transmit</Button>
                </Box>
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Dialog>
    )
}

export default UmaCounsellor